// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__Kbjor","detailsBorder":"styles_detailsBorder__1dOJJ"};